import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Flex, Text } from '@chilipiper/design-system'
import { Button, LinkButton, LoaderAnimation } from '@chilipiper/design-system/src/new'
import { OnboardingChiliPiperLogo } from '@chilipiper/onboarding'
import { routes } from '../../../routes/routes'
import { Link } from '../../../components/link/Link'
import { Spacer } from '../components/Spacer'
import { useOrganizationDetails, useRequestLicense, useUser } from '../../../api/workspace'

export const RequestLicenses = () => {
  const { data, isLoading } = useOrganizationDetails()
  const { mutateAsync: requestLicense, isPending: isRequestingLicense } = useRequestLicense()
  const { data: adminData } = useUser({
    enabled: Boolean(data?.adminId),
    userId: data?.adminId ?? '',
  })
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <Flex h='100%' w='100%' alignItems='center' justifyContent='center'>
        <LoaderAnimation />
      </Flex>
    )
  }
  const orgName = data?.name ?? 'Your organization'
  const orgAdminEmail = adminData?.email
  const orgLogo = data?.imageUrl

  const nextUrl = routes.onboarding.workingHours
  const handleRequestLicense = () => {
    requestLicense().then(() => {
      navigate(nextUrl)
    })
  }

  return (
    <Flex
      alignItems='center'
      w='100%'
      h='100%'
      flexDirection='column'
      bg='bg/minor'
      overflow='auto'
      px={6}
      py={5}
      position='relative'
    >
      <Spacer />
      <OnboardingChiliPiperLogo />
      <Flex flexDirection='column' alignItems='center' maxWidth='500px' w='100%'>
        {orgLogo && (
          <Box
            as='img'
            mb={7}
            src={orgLogo}
            alt={`${orgName} logo`}
            h='100px'
            w='auto'
            maxWidth='100%'
          />
        )}
        <Flex flexDirection='column' gap={6} alignItems='center'>
          <Text color='fg/major' fontSize={24} lineHeight={8} fontWeight={600} textAlign='center'>
            {orgName} is already up and running on&nbsp;ChiliCal&nbsp;✨
          </Text>
          <Text textStyle='body-multiline' color='fg/major' textAlign='center'>
            {orgAdminEmail && `Your company administrator is ${orgAdminEmail}.`} You can request a
            license to access Org features (such as Shared scheduling links) or skip for now and
            proceed to your Personal ChiliCal account:
          </Text>
          <Button
            variant='major'
            isFullWidth
            onClick={handleRequestLicense}
            isLoading={isRequestingLicense}
          >
            Request a license
          </Button>
          <Link to={nextUrl}>
            {linkProps => (
              <LinkButton variant='major' as='a' {...linkProps}>
                I just want to create a personal account
              </LinkButton>
            )}
          </Link>
        </Flex>
      </Flex>
      <Spacer />
    </Flex>
  )
}
